import { useCallback } from 'react';
import { PRINTER_PROFILES } from '../containers/PrinterProfiles/sagaMap';
import { isEmpty, printf } from '../utils';
import { mapProfile } from '../utils/printerProfile';

const useSummary = ({ getPrinterProfiles, updateField }) => {
  const getProfiles = useCallback(
    location => {
      if (isEmpty(location)) return;

      getPrinterProfiles({
        ...PRINTER_PROFILES,
        url: printf(PRINTER_PROFILES.url, location.id),
        callbackFn: list => {
          const mappedProfiles = !isEmpty(list) ? list.map(mapProfile) : [];

          updateField({
            profiles: mappedProfiles,
          });
        },
      });
    },
    [getPrinterProfiles, updateField],
  );

  return {
    getProfiles,
  };
};

export default useSummary;
